"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.getRiskIds = exports.create = exports.findNumberToCreate = exports.update = exports.getContainCycle = exports.updateMaps = exports.getAll = exports.get = void 0;
var PRC_1 = require("@cck/common/dist/data/PRC");
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var Admin = __importStar(require("../utils/Admin"));
var UpdateContainer_1 = __importStar(require("../utils/UpdateContainer"));
var ControlManager = __importStar(require("./ControlManager"));
var CycleManager = __importStar(require("./CycleManager"));
var RCMUtils_1 = require("./RCMUtils");
var RiskManager = __importStar(require("./RiskManager"));
var get = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).doc(id).get()];
            case 1: return [2 /*return*/, (_a.sent()).data()];
        }
    });
}); };
exports.get = get;
var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return docData.data(); })];
        }
    });
}); };
exports.getAll = getAll;
var updateMap = function (processId, updateObject) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUpdateObject, processObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalUpdateObject = {};
                return [4 /*yield*/, (0, exports.get)(processId)];
            case 1:
                processObject = _a.sent();
                lodash_1.default.forEach(['cycleIds', 'riskIds', 'controlIds'], function (targetKey) {
                    var newIds = (0, UpdateContainer_1.applyUpdateIds)(processObject[targetKey], updateObject === null || updateObject === void 0 ? void 0 : updateObject[targetKey]);
                    lodash_1.default.set(finalUpdateObject, targetKey, newIds);
                });
                return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).doc(processId).update(finalUpdateObject)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateMaps = function (updateObject) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(updateObject.values(), function (updateIds, id) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, updateMap(id, updateIds)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMaps = updateMaps;
var getContainCycle = function (controls) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleDataAll, processDataAll, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, CycleManager.getAll()]; // CYCLE 데이터 전체
            case 1:
                cycleDataAll = _a.sent() // CYCLE 데이터 전체
                ;
                return [4 /*yield*/, (0, exports.getAll)()]; // PROCESS 데이터 전체
            case 2:
                processDataAll = _a.sent() // PROCESS 데이터 전체
                ;
                return [4 /*yield*/, Admin.getOrCreateUser()];
            case 3:
                user = _a.sent();
                return [2 /*return*/, (0, lodash_1.default)(processDataAll)
                        .map(function (processObject) {
                        var cycleId = processObject.cycleIds[0];
                        var relateCycleObject = lodash_1.default.find(cycleDataAll, { id: cycleId });
                        if (!relateCycleObject) {
                            return undefined;
                        }
                        var controlIds = processObject.controlIds;
                        if ((user.level === 'UPLOADER' || user.level === 'NORMAL') &&
                            !lodash_1.default.some(controlIds, function (controlId) { return lodash_1.default.find(controls, { id: controlId }); })) {
                            return undefined;
                        }
                        processObject.type = PRC_1.PRCType.process;
                        processObject.cycleNumber = relateCycleObject.cycleNumber;
                        processObject.cycleName = relateCycleObject.cycleName;
                        processObject.categoryNumber = relateCycleObject.categoryNumber;
                        processObject.categoryName = relateCycleObject.categoryName;
                        processObject.subCategoryNumber = relateCycleObject.subCategoryNumber;
                        processObject.subCategoryName = relateCycleObject.subCategoryName;
                        return processObject;
                    })
                        .compact()
                        .value()];
        }
    });
}); };
exports.getContainCycle = getContainCycle;
var update = function (process) { return __awaiter(void 0, void 0, void 0, function () {
    var proceeId, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                proceeId = process.id;
                docRef = firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).doc(proceeId);
                return [4 /*yield*/, docRef.update({
                        name: process.name,
                        narrative: process.narrative
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.update = update;
var findNumberToCreate = function (cycleNumber, categoryNumber, subCategoryNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var processDataAll, cycleId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getAll)()];
            case 1:
                processDataAll = _a.sent();
                cycleId = [cycleNumber, categoryNumber, subCategoryNumber].join('-');
                return [2 /*return*/, (0, RCMUtils_1.getNewNumber)(cycleId, processDataAll)];
        }
    });
}); };
exports.findNumberToCreate = findNumberToCreate;
var makeUpdateMapFromCreate = function (processId, cycleId) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleUpdateMap;
    return __generator(this, function (_a) {
        cycleUpdateMap = new UpdateContainer_1.default();
        cycleUpdateMap.add(cycleId, 'processIds', processId);
        return [2 /*return*/, cycleUpdateMap];
    });
}); };
var create = function (processId, process) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleId, cycleUpdateMap, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, RCMUtils_1.isNotUniqueId)(processId)];
            case 1:
                /*
                새로운 PROCESS 를 만든다
                PROCESS 생성 시에 연결되는 CYCLE 정보를 모두 넣는다.(cycle, category, subCategory)
              
                속하는 CYCLE 의 processPathArray 에 PROCESS 를 추가한다
              
                @param: process: Process
                */
                if (_a.sent()) {
                    throw new Error("Not unique id ".concat(processId));
                }
                if (lodash_1.default.isEmpty(process.cycleIds)) {
                    throw new Error('Empty cycle id ');
                }
                cycleId = process.cycleIds[0];
                return [4 /*yield*/, makeUpdateMapFromCreate(processId, cycleId)];
            case 2:
                cycleUpdateMap = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).doc(processId);
                return [4 /*yield*/, docRef.set({
                        id: processId,
                        code: processId,
                        name: process.name,
                        narrative: process.narrative,
                        cycleIds: [cycleId],
                        riskIds: [],
                        controlIds: []
                    })];
            case 3:
                _a.sent();
                return [4 /*yield*/, CycleManager.updateMaps(cycleUpdateMap)];
            case 4:
                _a.sent();
                return [2 /*return*/, processId];
        }
    });
}); };
exports.create = create;
var getRiskIds = function (processId) { return __awaiter(void 0, void 0, void 0, function () {
    var processData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(processId)];
            case 1:
                processData = _a.sent();
                return [2 /*return*/, processData.riskIds];
        }
    });
}); };
exports.getRiskIds = getRiskIds;
var makeUpdateMapFromDelete = function (processId) { return __awaiter(void 0, void 0, void 0, function () {
    var processData, cycleId, cycleUpdateMap, riskUpdateMap, controlUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(processId)];
            case 1:
                processData = _a.sent();
                cycleId = processData.cycleIds[0];
                cycleUpdateMap = new UpdateContainer_1.default();
                cycleUpdateMap.add(cycleId, 'processIds', processId);
                riskUpdateMap = new UpdateContainer_1.default();
                riskUpdateMap.adds(processData.riskIds, 'processIds', processId);
                controlUpdateMap = new UpdateContainer_1.default();
                controlUpdateMap.adds(processData.controlIds, 'processIds', processId);
                return [2 /*return*/, { cycleUpdateMap: cycleUpdateMap, riskUpdateMap: riskUpdateMap, controlUpdateMap: controlUpdateMap }];
        }
    });
}); };
var remove = function (processId) { return __awaiter(void 0, void 0, void 0, function () {
    var riskIds, _a, cycleUpdateMap, riskUpdateMap, controlUpdateMap, docRef;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, exports.getRiskIds)(processId)];
            case 1:
                riskIds = _b.sent();
                if (riskIds.length > 0) {
                    // 연결된 RISK 가 존재. 삭제 불가
                    return [2 /*return*/, Promise.reject(new Error("\uC0AD\uC81C \uBD88\uAC00. \uC5F0\uACB0\uB41C RISK \uAC00 \uC874\uC7AC\uD569\uB2C8\uB2E4. ".concat(riskIds)))];
                }
                return [4 /*yield*/, makeUpdateMapFromDelete(processId)];
            case 2:
                _a = _b.sent(), cycleUpdateMap = _a.cycleUpdateMap, riskUpdateMap = _a.riskUpdateMap, controlUpdateMap = _a.controlUpdateMap;
                docRef = firebase.dbService.collection(RCMUtils_1.PROCESS_COLLECTION_NAME).doc(processId);
                return [4 /*yield*/, docRef.delete()];
            case 3:
                _b.sent();
                return [4 /*yield*/, CycleManager.updateMaps(cycleUpdateMap)];
            case 4:
                _b.sent();
                return [4 /*yield*/, RiskManager.updateMaps(riskUpdateMap)];
            case 5:
                _b.sent();
                return [4 /*yield*/, ControlManager.updateMaps(controlUpdateMap)];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.remove = remove;
//# sourceMappingURL=ProcessManager.js.map